import { render, staticRenderFns } from "./InstagramInstantwinAnalyticsPublicHeader.vue?vue&type=template&id=05ed64b5"
import script from "./InstagramInstantwinAnalyticsPublicHeader.vue?vue&type=script&lang=ts"
export * from "./InstagramInstantwinAnalyticsPublicHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports